define('GTMExtension.Main.EntryPoint', [
  'GTMExtension.Main.Model'
], function (
  GTMExtensionModel
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var layout = container.getComponent('Layout');
      var environment = container.getComponent('Environment');
      var config = environment && environment.getConfig('GTMExtension');
      var self = this;

      if(layout) {
        if(config && config.enable) {
          try {
            // GoogleTagManagerExt.loadModule();
            // eslint-disable-next-line
            if(dataLayer) {
              var tisUserInfo = self.getGTMContact();
              // if(tis_user_info){
              // 	// console.log('local', tis_user_info);
              // 	dataLayer.push({
              // 	  'user_id': tis_user_info.contact_id,
              // 	  'contact_id': tis_user_info.contact_id,
              // 	  'customer_id': tis_user_info.customer_id
              // 	});
              //
              // } else {
              self.fetchGTMContact().done(function (result) {
                tisUserInfo = result;
                // if(result && result.customer_id && result.customer_id == ''){
                // 	self.deleteCookie('uifl');
                // } else {
                // 	self.setCookie('uifl', self.encodeData(result), 15);
                // }
                // console.log('fetch', result);
                // eslint-disable-next-line
                dataLayer.push({
                  'user_id': tisUserInfo.contact_id,
                  'contact_id': tisUserInfo.contact_id,
                  'customer_id': tisUserInfo.customer_id
                });

                if(tisUserInfo && tisUserInfo.name && tisUserInfo.name.length > 0) {
                  layout.addToViewContextDefinition('Header.Profile.View', 'displayName', 'string', function () {
                    return tisUserInfo.name;
                  });
                }
              });
              // }
            }
          } catch (e) {
            console.log('gtm ext', e);
          }
        }
      }

    },
    // this gets data from backend
    fetchGTMContact: function () {
      var gtmExtModel = new GTMExtensionModel();
      var gtmExtModelPormise = gtmExtModel.fetch({
        async: false
      });
      return gtmExtModelPormise;
    },
    // this gets data locally
    getGTMContact: function () {
      var self = this;

      if(self.getCookie('uifl') && self.getCookie('uifl').length > 0) {
        var strUserInfo = self.getCookie('uifl');
        self.setCookie('uifl', strUserInfo, 15);
        strUserInfo = self.decodeData(strUserInfo);
        return strUserInfo;
      }
      return false;
    },

    encodeData: function (objJson) {
      var objStr = btoa(JSON.stringify(objJson));
      return objStr;
    },

    decodeData: function (objStr) {
      var objJson = atob(objStr);
      return JSON.parse(objJson);
    },

    getCookie: function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    },

    setCookie: function setCookie(name, value, minutes) {
      var d = new Date();
      d.setTime(d.getTime() + 60 * 1000 * minutes);
      document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
    },

    deleteCookie: function deleteCookie(name) {
      var self = this;
      self.setCookie(name, '', -1);
    }
  };
});
